import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            workspaceAgents: [],
            workspaceQueues: [],
            workspaceAccounts: [],
            workspaceIsPrivateSend : false,
        }
    },
    getters,
    actions,
    mutations
}